import { InputAdornment, TextField } from '@one-thd/sui-atomic-components';
import { Calendar } from '@one-thd/sui-icons';
import { DateTime } from 'luxon';
import React, { Dispatch, SetStateAction } from 'react';
import { TDateSelectValues } from '../../../models/common';

interface IOrderFilterInputProps {
  name: string;
  dateType: 'startDate' | 'endDate';
  dateSettings: {
    startDate: DateTime | string | null;
    endDate: DateTime | string | null;
    selectedDate: TDateSelectValues | null;
  };
  setDateSettings: Dispatch<
    SetStateAction<{
      selectedDate: TDateSelectValues | null;
      startDate: string | DateTime | null;
      endDate: string | DateTime | null;
    }>
  >;
  setFilterSettings: Dispatch<
    SetStateAction<{
      userView: string;
      customDateUsed: boolean;
      showStartCalendar: boolean;
      showEndCalendar: boolean;
      invalidStartDate: boolean;
      invalidEndDate: boolean;
    }>
  >;
}

export const OrderFilterInput = ({
  name,
  dateType,
  dateSettings,
  setDateSettings,
  setFilterSettings,
}: IOrderFilterInputProps) => {
  const label = { inputProps: { 'aria-label': 'date range' } };

  return (
    <TextField
      placeholder="MM/DD/YYYY"
      id="basic-input"
      fullWidth
      value={
        dateSettings?.selectedDate === 'custom' ? dateSettings[dateType] : ''
      }
      label={name}
      onChange={(event: { target: { value: string } }) => {
        let inputDate = event.target.value.replace(/[^0-9/]/g, '');

        if (inputDate.length > 10) {
          inputDate = inputDate.slice(0, 10);
        }

        if (
          inputDate.length === 2 &&
          dateSettings[dateType]?.toString().length !== 3
        ) {
          inputDate += '/';
        } else if (
          inputDate.length === 5 &&
          dateSettings[dateType]?.toString().length !== 6
        ) {
          inputDate += '/';
        }

        setDateSettings((prevState) => ({
          ...prevState,
          [dateType]: inputDate,
          selectedDate: 'custom',
        }));

        if (inputDate.length === 10) {
          const parsedDate = DateTime.fromFormat(inputDate, 'MM/dd/yyyy');

          const month = parsedDate.month;
          const day = parsedDate.day;
          const year = parsedDate.year;

          const monthString = month < 10 ? `0${month}` : `${month}`;
          const dayString = day < 10 ? `0${day}` : `${day}`;

          if (parsedDate.isValid) {
            setFilterSettings((prevState) => ({
              ...prevState,
              customDateUsed: true,
            }));
            setDateSettings((prevState) => ({
              ...prevState,
              selectedDate: 'custom',
              [dateType]: `${monthString}/${dayString}/${year}`,
            }));
          }
        }
        if (inputDate.length > 0) {
          setFilterSettings((prevState) => ({
            ...prevState,
            customDateUsed: true,
          }));
        }
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <span
              className="sui-cursor-pointer sui-flex"
              onClick={() => {
                if (dateType === 'startDate') {
                  setFilterSettings((prevState) => ({
                    ...prevState,
                    showStartCalendar: true,
                  }));
                } else if (dateType === 'endDate') {
                  setFilterSettings((prevState) => ({
                    ...prevState,
                    showEndCalendar: true,
                  }));
                }
              }}
              onKeyDown={() => {
                if (dateType === 'startDate') {
                  setFilterSettings((prevState) => ({
                    ...prevState,
                    showStartCalendar: true,
                  }));
                } else if (dateType === 'endDate') {
                  setFilterSettings((prevState) => ({
                    ...prevState,
                    showEndCalendar: true,
                  }));
                }
              }}
              tabIndex={0}
              role="button"
              aria-label="Open date picker"
            >
              <Calendar size="small" />
            </span>
          </InputAdornment>
        ),
        ...label,
      }}
    />
  );
};
